export default __webpack_public_path__ + "static/plotty-empty-state-621d8c53a19f8e571396a4c55a75bd8d.svg";